import React from 'react';
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { I18nextProvider } from 'react-i18next';
import i18n, { i18nReady } from './lib/i18n';
import { unregisterServiceWorker } from './lib/serviceWorker';

// Hard-disable Service Worker (ensures no SW controls the page)
unregisterServiceWorker();

// Clear all caches and service workers
console.log('[DEBUG] Clearing all caches and service workers');
if ('caches' in window) {
  caches.keys().then(names => names.forEach(name => caches.delete(name)));
}
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => registrations.forEach(reg => reg.unregister()));
}

// Čakaj na i18n a potom renderuj aplikáciu
i18nReady.then(() => {
  const root = createRoot(document.getElementById('root')!);
  
  // Demo landing disabled — always render App
  root.render(
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  );
});
